import React, { ReactNode } from 'react';
import {
  Checkbox,
  Chip,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import CloseIcon from '@old/assets/svg/close.svg';
import { stylesInput } from '@old/styles/generic-styles';

type Option2 = {
  id: string | number;
  name?: string;
  color?: 'error' | 'warning' | 'secondary' | 'primary';
};

type Color = 'error' | 'warning' | 'secondary' | 'primary';

type Options =
  | {
      id?: string | number;
      name?: string;
      color?: Color;
      [key: string]: unknown;
    }[]
  | undefined;

// TODO: Hay valores any que deberían ser tipados
type CustomSelectProps = {
  label: string;
  id: string;
  value: string | number | (string | number)[] | boolean;
  onChange?: (event: SelectChangeEvent<unknown>, child: React.ReactNode) => void;
  options?: Options;
  multiple?: boolean;
  disabled?: boolean;
  renderValue?: (selected: unknown) => React.ReactNode;
  placeholder?: string;
  deleteFilter?: () => void;
  selectedList?: Option2[] | number | string | boolean;
  withChip?: boolean;
  propToShow?: string;
};

export function Selector({
  label,
  id,
  value,
  onChange,
  options,
  multiple = false,
  disabled = false,
  renderValue,
  placeholder,
  deleteFilter,
  selectedList,
  withChip = false,
  propToShow,
}: CustomSelectProps) {
  const hasSelectedItems =
    value === true ||
    value === false ||
    (Array.isArray(selectedList) && selectedList.length > 0) ||
    typeof value === 'number';

  return (
    <FormControl variant="outlined" size="medium" style={{ width: '98%' }} sx={stylesInput}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        input={<OutlinedInput label={label} />}
        value={value}
        onChange={(event, child) => onChange?.(event as unknown as SelectChangeEvent<unknown>, child)}
        multiple={multiple}
        disabled={disabled}
        renderValue={renderValue}
        endAdornment={
          <IconButton onClick={deleteFilter} sx={{ visibility: hasSelectedItems ? 'visible' : 'hidden' }}>
            <img src={CloseIcon} alt="cross-icon" />
          </IconButton>
        }
        sx={{
          '& .MuiSelect-outlined ~ .MuiSelect-icon': { display: hasSelectedItems ? 'none' : '' },
        }}
      >
        {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
        {options?.map((item) => (
          <MenuItem
            key={(item.id as string) ?? (item[propToShow as string] as string)}
            value={(item.id as string) ?? item[propToShow!]}
            style={{ color: item.color as Color }}
          >
            {multiple && Array.isArray(selectedList) && (
              <Checkbox checked={selectedList?.some((selectedItem) => selectedItem.id === item.id)} />
            )}
            {withChip && (
              <Chip
                label=""
                color={(item as Option2).color}
                style={{
                  height: '0.7rem',
                  width: '1rem',
                  marginRight: '0.5rem',
                }}
              />
            )}
            {(item.name ?? item[propToShow as string]) as ReactNode}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
